export const POSTHOG_API_HOST = "https://eu.i.posthog.com";

export function getPosthogConfig(): { key: string; host: string } | undefined {
  const disabled =
    import.meta.env.VITE_DISABLE_POSTHOG_ON_HOSTS?.includes(window.location.host) ?? false;
  const key = import.meta.env.VITE_POSTHOG_KEY;
  if (disabled || !key) {
    return undefined;
  }
  return { key, host: POSTHOG_API_HOST };
}
